(() => {
  const configNode = document.getElementById('KrugBagConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const root = config.root || '/';
  const storageKey = 'krug:saved-products:v1';
  const safePath = path => typeof path === 'string' && /^\/(?!\/)/.test(path);
  const validProduct = p => p && typeof p.handle === 'string' && /^[a-z0-9-]+$/.test(p.handle) && typeof p.title === 'string' && safePath(p.url);
  const readSaved = () => {
    try { const list = JSON.parse(localStorage.getItem(storageKey) || '[]'); return Array.isArray(list) ? list.filter(validProduct).slice(0,100) : []; } catch { return []; }
  };
  const showMessage = message => { document.querySelectorAll('[data-saved-message]').forEach(el => { el.textContent = message; }); };
  const writeSaved = list => {
    try { localStorage.setItem(storageKey, JSON.stringify(list)); return true; } catch { showMessage(config.storageError); return false; }
  };
  const imageUrl = value => { try { const url = new URL(value, location.origin); return ['https:','http:'].includes(url.protocol) ? url.href : ''; } catch { return ''; } };
  const money = (value, currency) => new Intl.NumberFormat(document.documentElement.lang || 'de-AT', {style:'currency',currency:currency || config.currency}).format(value / 100);
  const element = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; };
  const previewLink = link => {
    const body = document.body;
    if (body.dataset.krugThemeRole !== 'main' && body.dataset.krugDesignMode !== 'true' && body.dataset.krugThemeId) {
      const u = new URL(link.href, location.origin); u.searchParams.set('preview_theme_id', body.dataset.krugThemeId); link.href = u.pathname + u.search;
    }
  };
  function syncButtons() {
    const saved = readSaved();
    document.querySelectorAll('[data-krug-save]').forEach(button => {
      let product; try { product = JSON.parse(button.dataset.krugSave); } catch { return; }
      if (!validProduct(product)) return;
      const active = saved.some(p => p.handle === product.handle);
      button.hidden = false; button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', (active ? config.unsave : config.save) + ': ' + product.title);
      const label = button.querySelector('[data-save-label]'); if (label) label.textContent = active ? config.saved : config.save;
    });
  }
  let renderVersion = 0;
  async function renderSaved() {
    const page = document.querySelector('[data-saved-page]'); if (!page) return;
    const version = ++renderVersion;
    const list = readSaved(), grid = page.querySelector('[data-saved-grid]'), empty = page.querySelector('[data-saved-empty]');
    grid.replaceChildren(); grid.hidden = list.length === 0; empty.hidden = list.length > 0;
    list.forEach(saved => {
      const card = element('article','krug-saved-card'), link = element('a','card'); link.href = saved.url; previewLink(link);
      const picture = element('div','card-image'), img = element('img'); const source = imageUrl(saved.image);
      if (source) { img.src = source; img.alt = saved.title; img.loading = 'lazy'; picture.append(img); }
      const copy = element('div','card-copy'), title = element('h3',null,saved.title), price = element('p',null,config.viewDetails);
      copy.append(title,price); link.append(picture,copy);
      const remove = element('button','krug-saved-remove',config.unsave); remove.type = 'button'; remove.setAttribute('aria-label',config.unsave + ': ' + saved.title);
      remove.addEventListener('click',() => { if (writeSaved(readSaved().filter(p => p.handle !== saved.handle))) { syncButtons(); renderSaved(); } });
      card.append(link,remove); grid.append(card);
      fetch(root + 'products/' + encodeURIComponent(saved.handle) + '.js').then(r => { if (!r.ok) throw Error(); return r.json(); }).then(product => {
        if (version !== renderVersion || !card.isConnected) return;
        title.textContent = product.title || saved.title;
        price.textContent = product.available ? (product.price_varies ? config.from + ' ' : '') + money(product.price) : config.soldOut;
        const liveImage = imageUrl(product.featured_image); if (liveImage) { img.src = liveImage; img.alt = title.textContent; if (!img.parentNode) picture.append(img); }
      }).catch(() => {});
    });
  }
  function setupBag() {
    const bag = document.querySelector('[data-krug-bag]'); if (!bag || bag.dataset.initialized) return;
    bag.dataset.initialized = 'true'; const summary = bag.querySelector('summary');
    const close = returnFocus => { bag.open = false; document.documentElement.classList.remove('krug-bag-open'); summary.setAttribute('aria-expanded','false'); if (returnFocus) summary.focus(); };
    summary.setAttribute('aria-expanded',String(bag.open));
    bag.querySelectorAll('[data-bag-close]').forEach(button => button.addEventListener('click',() => close(true)));
    bag.addEventListener('toggle',async () => {
      summary.setAttribute('aria-expanded',String(bag.open)); document.documentElement.classList.toggle('krug-bag-open',bag.open);
      if (!bag.open) return;
      const header = bag.closest('.header'); if (header) document.documentElement.style.setProperty('--krug-header-bottom', Math.max(0,header.getBoundingClientRect().bottom) + 'px');
      document.querySelectorAll('.mobile-menu[open],.nav-dropdown[open]').forEach(d => { d.open = false; });
      try {
        const response = await fetch(root + 'cart.js',{headers:{Accept:'application/json'}}); if (!response.ok) return;
        const cart = await response.json();
        bag.querySelector('[data-bag-title]').textContent = cart.item_count ? config.title : config.emptyTitle;
        const count = bag.querySelector('[data-bag-count]'); count.textContent = cart.item_count; count.hidden = !cart.item_count;
        const items = bag.querySelector('[data-bag-items]'); items.replaceChildren();
        (cart.items || []).forEach(item => {
          if (!safePath(item.url)) return;
          const a = element('a','krug-bag-item'); a.href = item.url; previewLink(a);
          const src = imageUrl(item.image); if (src) { const img = element('img'); img.src = src; img.alt = item.product_title || item.title; a.append(img); }
          const title = element('span',null,item.product_title || item.title); title.append(element('small',null,item.quantity + ' × ' + money(item.final_price,cart.currency))); a.append(title); items.append(a);
        });
        bag.querySelector('[data-bag-checkout]').hidden = !cart.item_count;
        bag.querySelector('[data-bag-total]').textContent = money(cart.total_price,cart.currency);
      } catch { /* Keep the server-rendered shopping bag available. */ }
    });
    document.addEventListener('keydown',e => { if (e.key === 'Escape' && bag.open) close(true); });
    document.addEventListener('click',e => { if (bag.open && !bag.contains(e.target)) close(false); });
    document.addEventListener('focusin',e => { if (bag.open && !bag.contains(e.target)) close(false); });
  }
  document.addEventListener('click',e => {
    const button = e.target.closest('[data-krug-save]'); if (!button) return;
    let product; try { product = JSON.parse(button.dataset.krugSave); } catch { return; }
    if (!validProduct(product)) return;
    const list = readSaved(), active = list.some(p => p.handle === product.handle);
    if (writeSaved(active ? list.filter(p => p.handle !== product.handle) : [product,...list].slice(0,100))) { syncButtons(); renderSaved(); }
  });
  function init() { setupBag(); syncButtons(); renderSaved(); }
  window.addEventListener('storage',e => { if (e.key === storageKey) { syncButtons(); renderSaved(); } });
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('krug:products-updated',syncButtons);
  init();
})();
